import React from 'react';
import { ElegirPack } from './pages/ElegirPack';
export function App() {
  return <ElegirPack data-id="element-0" />;
}